import { Col, Divider, Form, Image, Input, InputNumber, Row, Select, Upload, message } from "antd";
import { ImagePreview, UploadButton, createHandlePreview, createHandleUpload } from "../../utils/uploadUtils.jsx";

import permissions from "../../../configs/permission";
import { usePermission } from "../../hooks/usePermission";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const CreateOriginPackageDetail = ({
  t,
  formOriginPackage,
  validateDataOriginPackageRequired,
  setFileList,
  fileList,
  type,
}) => {
  const { hasPermission, isSuperuser } = usePermission();
  const isReadOnlyByPermission = type === "EDIT" && !isSuperuser && !hasPermission(permissions.OriginPackage.CHANGE);
  const [messageApi, contextHolder] = message.useMessage();
  const { t: tOps } = useTranslation("options", { keyPrefix: "Package" });

  /* eslint-enable no-template-curly-in-string */
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handleUpload = createHandleUpload(messageApi);

  const beforeUpload = (file) => {
    const isLt12M = file.size / 1024 / 1024 < 12;

    if (!isLt12M) {
      message.error("Image must smaller than 12MB!");
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const originPackageWeightType = [
    { value: "normal", label: tOps("Weight_Type.Normal") },
    { value: "mixed", label: tOps("Weight_Type.Mixed") },
  ];

  const originPackageType = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "D", label: "D" },
    { value: "E", label: "E" },
  ];

  const packageStatus = [
    { value: "0", label: tOps("Package_Status.At_The_Origin_Warehouse") },
    { value: "1", label: tOps("Package_Status.Transporting_To_The_Destination_Warehouse") },
    { value: "2", label: tOps("Package_Status.At_The_Destination_Warehouse") },
    { value: "3", label: tOps("Package_Status.Delivered") },
  ];

  const handlePreview = createHandlePreview(setPreviewImage, setPreviewOpen);

  const uploadButton = <UploadButton />;

  return (
    <>
      {contextHolder}
      <Row align="top" justify="center">
        <Col span={12}>
          <Row gutter={10}>
            <Col flex={6}>
              <Form
                form={formOriginPackage}
                labelAlign="left"
                labelCol={{ flex: "170px" }}
                disabled={isReadOnlyByPermission}
              >
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Desscription") + ":"}
                    name="description_detail"
                    key="description_detail"
                    style={{ marginBottom: "1rem" }}
                    normalize={(value) => value.trim()}
                    hasFeedback
                  >
                    <Input size="default" placeholder={"description"} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Type") + ":"}
                    name="type"
                    key="type"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                    initialValue={"A"}
                  >
                    <Select style={{ width: "100%" }} options={originPackageType} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Package_Status") + ":"}
                    name="package_status"
                    key="package_status"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                    initialValue={"0"}
                  >
                    <Select style={{ width: "100%" }} options={packageStatus} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Total_Count") + ":"}
                    name="total_count"
                    key="total_count"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                    initialValue={1}
                  >
                    <InputNumber style={{ width: "100%" }} min={1} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Length") + ":"}
                    name="length"
                    key="length"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <InputNumber style={{ width: "100%" }} min={1} addonAfter={"cm"} step="1.00" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Width") + ":"}
                    name="width"
                    key="width"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <InputNumber style={{ width: "100%" }} min={1} addonAfter={"cm"} step="1.00" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Height") + ":"}
                    name="height"
                    key="height"
                    style={{ marginBottom: "1rem" }}
                    rules={[
                      {
                        required: true,
                      },
                      {
                        validator: validateDataOriginPackageRequired,
                      },
                    ]}
                    hasFeedback
                  >
                    <InputNumber style={{ width: "100%" }} min={1} addonAfter={"cm"} step="1.00" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Weight") + ":"}
                    name="weight"
                    key="weight"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                  >
                    <InputNumber style={{ width: "100%" }} min={0.0001} addonAfter={"kg"} step={0.0001} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Weight_Type") + ":"}
                    name="weight_type"
                    key="weight_type"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                    initialValue={"normal"}
                  >
                    <Select style={{ width: "100%" }} options={originPackageWeightType} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Origin_Package_Create.Create_Detail.Input_Amount") + ":"}
                    name="amount"
                    key="amount"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataOriginPackageRequired }]}
                    hasFeedback
                    initialValue={"1"}
                  >
                    <InputNumber style={{ width: "100%" }} min={1} max={9999} />
                  </Form.Item>
                </Col>
                <Divider />
              </Form>
            </Col>
            <Col flex={1}></Col>
          </Row>
        </Col>
        <Col span={12}>
          <Form form={formOriginPackage} labelCol={{ flex: "130px" }} disabled={isReadOnlyByPermission}>
            <Row gutter={10} style={{ justifyContent: "left", alignSelf: "baseline" }}>
              <Col span={24}>
                <div style={{ marginBottom: 8 }}>{t("Origin_Package_Create.Create_Detail.Upload_Title")}</div>
                <Row gutter={[16, 16]}>
                  {[...Array(12)].map((_, index) => (
                    <Col xs={12} sm={12} md={6} key={index}>
                      <Upload
                        customRequest={handleUpload}
                        // beforeUpload={beforeUpload}
                        listType="picture-card"
                        fileList={fileList[index] ? [fileList[index]] : []}
                        onPreview={handlePreview}
                        disabled={
                          isReadOnlyByPermission ||
                          (type === "CREATE" && !hasPermission(permissions.OriginPackageImage.ADD)) ||
                          (type === "EDIT" && !hasPermission(permissions.OriginPackageImage.CHANGE))
                        }
                        onChange={({ fileList: newList }) => {
                          const file = newList[0];
                          if (!file) {
                            const newFileList = [...fileList];
                            newFileList[index] = null;
                            setFileList(newFileList);
                            return;
                          }
                          const isDuplicate =
                            file.name && fileList.some((f, i) => f && f.name === file.name && i !== index);

                          if (isDuplicate) {
                            message.error("ชื่อไฟล์ซ้ำ กรุณาเปลี่ยนชื่อไฟล์");
                            return;
                          }

                          const newFileList = [...fileList];
                          newFileList[index] = file;
                          setFileList(newFileList);
                        }}
                        onRemove={() => {
                          const canRemove =
                            hasPermission(permissions.OriginPackageImage.DELETE) ||
                            hasPermission(permissions.OriginPackageImage.ADD) ||
                            hasPermission(permissions.OriginPackageImage.CHANGE);
                          if (!canRemove) {
                            message.warning("You are not allowed to remove this file.");
                            return false; // Prevent remove
                          }
                          const newFileList = [...fileList];
                          newFileList[index] = null;
                          setFileList(newFileList);
                        }}
                        maxCount={1}
                      >
                        {fileList[index] ? null : uploadButton}
                      </Upload>
                      <div style={{ textAlign: "left" }}>Package {index + 1}</div>
                    </Col>
                  ))}
                </Row>
                <ImagePreview
                  previewImage={previewImage}
                  previewOpen={previewOpen}
                  setPreviewOpen={setPreviewOpen}
                  setPreviewImage={setPreviewImage}
                  Image={Image}
                />
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
};
